module.exports = __webpack_public_path__ + "img/invitation-to-mundane-life-2.63acc00d.webp";